module.exports = "\r\n.marginLateral{\r\n\r\n    margin-left: 25px;\r\n    margin-right: 25px;\r\n}"